import {
  Button,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";
import cardioLogo from "../../constants/images/logo_color_Cardio_Protecccion.png";
import { Link } from "react-router-dom";

const ResetPassword = ({ firebase }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = new URLSearchParams(window.location.search);

  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [error, setError] = useState(null);
  const [viewPassword, setviewPassword] = useState(false);
  const [psw1, setPsw1] = useState("");
  const [psw2, setPsw2] = useState("");
  const [isCodeExpired, setIsCodeExpired] = useState(false);

  useEffect(() => {
    firebase.verifyPasswordResetCode(params.get("oobCode")).catch((error) => {
      error.code == "auth/invalid-action-code" && setIsCodeExpired(true);
      error.code == "auth/expired-action-code" && setIsCodeExpired(true);
      setError("auth.auth/expired-action-code");
    });
  }, []);

  const onchange = (e) => {
    if (e.target.name == "psw1") {
      setPsw1(e.target.value);
    } else {
      setPsw2(e.target.value);
    }
  };

  const changePassword = () => {
    if (psw1 !== "" && psw1 == psw2) {
      setError(null);
      firebase
        .confirmPasswordReset(params.get("oobCode"), psw1)
        .then(() => {
          !!firebase.currentUser() && firebase.user(firebase.currentUser().uid).child("sgpfc").update({ lastPasswordChange: new Date().getTime() });
          history.push(ROUTES.SIGN_IN);
        })
        .catch((error) => {
          setError("auth." + error.code);
        });
    } else {
      setError("passwordNotSame");
    }
  };

  const isValid = psw1 !== "" && psw1 == psw2;

  return (
    <Grid container justify="center" alignItems="center" style={{ minHeight: "100vh", paddingRight: 12, paddingLeft: 12 }}>
      <Grid container item xs={12} md={4} xl={3}>
        <Grid item xs={12}>
          <Paper variant="outlined" style={{ minHeight: "80vh", padding: 32, position: "relative" }}>
            <Grid container justify="center" spacing={4}>
              <Grid style={{ marginTop: 32 }}>
                <Grid item xs={12} container justify="center">
                  <img src={cardioLogo} style={{ height: 80 }} />
                </Grid>
                <Grid item xs={12} container justify="center">
                  <Typography
                    variant="h6"
                    style={{
                      paddingTop: 16,
                      fontSize: 24,
                      textAlign: "center",
                      fontWeight: 400,
                      marginBottom: 0,
                    }}
                  >
                    {t("resetPasswordTitleEmail")}
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  variant="body1"
                  style={{
                    marginTop: 16,
                    marginBottom: 18,
                    color: "#202124",
                    fontSize: 16,
                    textAlign: "center",
                    fontWeight: 400,
                    letterSpacing: 0.1,
                    lineHeight: 1.5,
                  }}
                >
                  {t("resetPasswordTextPassword")}
                </Typography>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel htmlFor="outlined-adornment-password">{t("password")}</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={viewPassword ? "text" : "password"}
                      name="psw1"
                      value={psw1}
                      error={!!error}
                      onChange={onchange}
                      labelWidth={(t("password") + " ").length * 7.75}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              setviewPassword(!viewPassword);
                            }}
                            onMouseDown={() => {
                              setviewPassword(!viewPassword);
                            }}
                            edge="end"
                          >
                            {viewPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel htmlFor="outlined-adornment-password2">{t("repeatPassword")}</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password2"
                      type={viewPassword ? "text" : "password"}
                      name="psw2"
                      value={psw2}
                      error={!!error}
                      onChange={onchange}
                      labelWidth={t("repeatPassword").length * 7.5}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                              setviewPassword(!viewPassword);
                            }}
                            onMouseDown={() => {
                              setviewPassword(!viewPassword);
                            }}
                            edge="end"
                          >
                            {viewPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {!!error && <FormHelperText error>{t(error)}</FormHelperText>}
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: 18, marginBottom: 18 }}>
                <Grid item xs={12} container justify="flex-end">
                  <Button disabled={isCodeExpired} variant="outlined" color="primary" onClick={changePassword}>
                    {t("resetPasswrod")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              container
              justify="center"
              style={{
                position: "absolute",
                width: "100%",
                bottom: 8,
                left: 0,
              }}
            >
              <Link to={ROUTES.HOME} style={{ textDecoration: "none" }}>
                <Typography color="textSecondary">{t("home")}</Typography>
              </Link>
              <Typography color="textSecondary" style={{ marginRight: 4, marginLeft: 4 }}>
                ·
              </Typography>
              <a href={"mailto:info@bexencardio.com"} style={{ textDecoration: "none" }}>
                <Typography color="textSecondary">{t("help")}</Typography>
              </a>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={() => {
          setOpenSnackBar(false);
        }}
      >
        <Alert
          onClose={() => {
            setOpenSnackBar(false);
          }}
          severity="success"
        >
          {t("checkEmail")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default withFirebase(ResetPassword);
